/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'good': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M944.7 418.1c-13.4-16.1-33.5-25.5-54.9-25.5H648.5c7.5-15.3 15.6-33.1 23-52.1 13.3-33.9 21.9-64.7 25.5-91.7 5.1-37.9.4-69.5-13.9-93.7-25.6-43.4-74-52.5-110.1-52.5-38.9 0-72 19.5-98.2 57.9-19.7 28.8-34.3 65.9-48.4 101.8-31 78.7-54.7 130.3-99.8 130.3H132.9c-38.9 0-70.4 30.6-70.4 68.2v392.3c0 37.7 31.5 68.2 70.4 68.2h669.2c33 0 61.6-22.2 68.8-53.4v-.2l87.7-392.2c4.5-20.2-.6-41.3-13.9-57.4zm-811.8 42.7h105.6v392.3H132.9V460.8zm756.9.2l-87.7 392.1H308.9V460.8h17.6c44.5 0 81.9-21.1 111.6-62.8 22.8-32.1 38.6-72.4 54-111.4 27.5-69.9 48-115.8 80.8-115.8 38.3 0 46.4 13.6 49 18.1 6.1 10.2 16.6 43.1-15.9 126.4-12.9 32.4-28.2 63.8-45.9 94-6.4 10.6-6.5 23.6-.2 34.2 6.3 10.6 17.9 17.2 30.6 17.2h299.3v.3z" _fill="#0C0C0C"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/good.js